import { render } from "./AudioTable.vue?vue&type=template&id=19a6d281&scoped=true"
import script from "./AudioTable.vue?vue&type=script&lang=js"
export * from "./AudioTable.vue?vue&type=script&lang=js"

import "./AudioTable.vue?vue&type=style&index=0&id=19a6d281&scoped=true&lang=scss"

import exportComponent from "/Users/eduardopassos/Documents/Dev/blat/subsextract/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a6d281"]])

export default __exports__